import React, { Component } from 'react';
import store from '../../store';
import { HandleSubmit } from '../../func/HandleSubmit';
import cookie from "../../func/Cookie";
import matchSorter from 'match-sorter'
import ReactTable from 'react-table-6'
import "react-table-6/react-table.css";
import ProgressList from '../Progress/ProgressList';
//import './basic.css';

const StatusNum = {
    prepishfactor: 5,
    pishfactor: 10,
    factor: 20,
    tahvil: 30,
    preafzayesh: 55,
    laghv: 40,
    afzayesh: 60,
}
class RequestList extends Component {
    reqest_number = "";
    myRef = [];
    constructor(props) {
        super(props);
        this.state = {
            TableOfRequest: [],
            TableOfRequestCounter: 0,
            Loading: true,
            show_view_row: [],
            SubPage: this.props.subpage,
            Action: "",
            SelectPage: 0,
            PageSize: 10,
            Pages: 1,
            StateName: [],
            SendParameters: {
                progress: {
                    pishfactor: 10,
                    factor: 20,
                    tahvil: 30,
                    cancel: 40,
                    afzayesh: 60,
                },
                table_parameter: {
                    pageSize: null,
                    page: null,
                    sorted: null,
                    filtered: null
                }
            },
            refStatus: false
        };
        this.reloadAgain = this.reloadAgain.bind(this);
        this.OnFetchTableOfRequest = this.OnFetchTableOfRequest.bind(this);

    }
    reloadAgain() {
        let TableState = {};
        TableState.pageSize = this.state.SendParameters.table_parameter.pageSize;
        TableState.page = this.state.SendParameters.table_parameter.page;
        TableState.sorted = this.state.SendParameters.table_parameter.sorted;
        TableState.filtered = this.state.SendParameters.table_parameter.filtered;
        this.OnFetchTableOfRequest(TableState)
    }
    async OnFetchTableOfRequest(TableState) {
        //console.log("tablestatae", TableState);
        this.state.SendParameters.table_parameter.pageSize = TableState.pageSize;
        this.state.SendParameters.table_parameter.page = TableState.page;
        this.state.SendParameters.table_parameter.sorted = TableState.sorted;
        this.state.SendParameters.table_parameter.filtered = TableState.filtered;
        //this.state.SendParameters.getlen = TableState.pageSize;
        this.setState({
            Loading: true,
            SendParameters: this.state.SendParameters,
        })
        var response_info = await HandleSubmit('getdata/gettableofrequestforreport', this.state.SendParameters);
        this.setState({
            TableOfRequest: (response_info).items,
            Pages: Math.ceil(((response_info).record_count) / TableState.pageSize),
            PageSize: TableState.pageSize,
            Loading: false,
        });
    }
    async GetState() {
        var response_info = await HandleSubmit('getdata/getstate', this.state.SendParameters);
        //console.log("getstate", response_info);
        this.setState({
            StateName: response_info,
        });

    }
    async componentDidMount() {
        store.dispatch({ type: 'reports' });
        await this.GetState();
    }
    componentWillReceiveProps() {
        this.setState({
            SubPage: this.props.subpage
        });
    }
    render() {
        return (
            <div>
                <div style={{
                    fontSize: "24px",
                    color: "red",
                    border: "3px solid rgba(0, 150, 255, 0.91)",
                    borderRadius: "10px",
                }}>گزارشات</div>
                {/* <div> <DatePicker /></div> */}
                <ReactTable
                    manual
                    //page={this.state.SelectPage}
                    pages={this.state.Pages} // Display the total number of pages
                    pageSize={this.state.PageSize}
                    //defaultPageSize={10}
                    loading={this.state.Loading} // Display the loading overlay when we need it
                    onFetchData={this.OnFetchTableOfRequest}
                    className="-hover -responsive -striped -highlight"
                    filterable
                    SubComponent={(row) => (<ProgressList action="view" request_code={row.original.request_code}
                        reloadagain={this.reloadAgain} />)}
                    headerStyle={{ fontWeight: "bold", fontcolor: "red" }}
                    data={this.state.TableOfRequest}
                    //filterable
                    defaultSorted={[{
                        id: "request_code", desc: true
                    }]}
                    columns={[
                        {
                            expander: true,
                            width: 100,
                            //minWidth: 200,
                            Expander: ({ isExpanded, ...rest }) => {
                                return (
                                    <div>{isExpanded ? <span><button >-</button></span> : <span><button>+</button></span>}</div>
                                );
                            }
                        },
                        {
                            Header: "#",
                            accessor: "row",
                            maxWidth: 100,
                            minWidth: 30,
                            filterable: false,
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}>  شماره سفارش  </div>,
                            accessor: "request_code",
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}> صاحب سفارش  </div>,
                            accessor: "request_owner",
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}> صادر کننده</div>,
                            accessor: "user_name",

                        },
                        {
                            maxWidth: 300,
                            minWidth: 200,
                            Header: () => <div style={{ fontWeight: "bold" }}> تاریخ </div>,
                            accessor: "date"
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}> توضیحات </div>,
                            accessor: "desc",
                            filterable: false,
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}> شماره فاکتور </div>,
                            accessor: "factor_num",
                            filtered: false,
                            filterable: false,
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}> وضعیت فعلی  </div>,
                            accessor: "status_name",
                            Filter: ({ filter, onChange }) =>
                                <select
                                    onChange={event => onChange(event.target.value)}
                                    style={{ width: "100%" }}
                                    value={filter ? filter.value : "all"}
                                >
                                    {this.state.StateName.map(item =>
                                        <option key={item.row} value={item.value}>{item.label}</option>
                                    )};
                                        </select>
                        }
                    ]}
                    className="-striped -highlight"
                />
            </div >
        );
    }
}
export default (RequestList);







// WEBPACK FOOTER //
// ./src/pages/Request/RequestList.js